import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Tag from '@/model/entity/taxonomy/tag';
import { debounce } from 'lodash';

@Component
export default class TagSelectorComponent extends Vue
{
    @Prop()
    private value!: Tag[];

    private tags: Tag[]|string[] = [];

    private search: string|null = null;
    private results: Tag[] = [];
    private loading = false;

    private created(): void
    {
        this.tags = [ ...this.value ];

        this.results = [ ...this.tags ];
    }

    @Watch('value')
    private onValueChanged()
    {
        this.tags = [ ...this.value ];

        this.results = [ ...this.tags ];
    }

    @Watch('search')
    private debouncedOnSearchChanged = debounce(this.onSearchChanged, 50);

    private async onSearchChanged()
    {
        if (!this.search)
        {
            this.results = [];
            return;
        }

        try
        {
            this.loading = true;

            this.results = await this.$serviceContainer.tagService.findTags({
                title: this.search,
            });
        }
        finally
        {
            this.loading = false;
        }
    }

    /**
     * Handles value updates
     */

    private onUpdate()
    {
        this.$emit('input', this.tags);
    }
}